module.exports = __webpack_public_path__ + "img/img12.c231f0d9.jpg";